import { useEffect, useState } from "react";

import { IconX } from "@tabler/icons";

import { useAppDispatch, useAppSelector } from "@sso/hooks/useRedux";
import { detachedSnackbar, selectSnackbar } from "@sso/store/slices/snackbar";
import { IconButton } from "@sso/ui/IconButton";
import { Typography } from "@sso/ui/Typography";

import { SnackbarBox } from "./SnackbarBox";
import { SnackbarIcon } from "./SnackbarIcon";

export const Snanckbar = () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const { title, type, closed } = useAppSelector(selectSnackbar);

  const handleCloseSnackbar = () => setOpen(false);
  const handleDetachedSnackbar = () => !open && dispatch(detachedSnackbar());

  useEffect(() => {
    if (closed) {
      return setOpen(false);
    }
    setOpen(true);
    const timer = setTimeout(() => {
      setOpen(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, [closed, title]);

  return closed ? null : (
    <SnackbarBox open={open} type={type} onTransitionEnd={handleDetachedSnackbar}>
      <SnackbarIcon type={type} />
      <Typography color="inherit" margin="0 0.5rem" textAlign="left">
        {title}
      </Typography>
      <IconButton color="inherit" margin="0 0 0 auto" onClick={handleCloseSnackbar}>
        <IconX />
      </IconButton>
    </SnackbarBox>
  );
};
